import { render, staticRenderFns } from "./Create-Job.vue?vue&type=template&id=6a8aa585&scoped=true"
import script from "./Create-Job.vue?vue&type=script&lang=js"
export * from "./Create-Job.vue?vue&type=script&lang=js"
import style1 from "./Create-Job.vue?vue&type=style&index=1&id=6a8aa585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8aa585",
  null
  
)

export default component.exports